import { memo, useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'

import { ContextMenu, Item, MenuButton } from 'basic-components'
import { FatArrowDown } from 'basic-components/icons'

import './AccessContextMenu.scss'

const AccessContextMenu = ({ onAccessChange, access, disabled = false }) => {
  const contextTitle = useMemo(() => (
          <MenuButton
              disabled={disabled}
              key="MenuButton"
          >
            <div className="data-lake__group-dialog__share__access">
              <span>{access === "R" ? "Viewer" : "Editor"}</span>
              <FatArrowDown color="black-base"/>
            </div>
          </MenuButton>
        ), [access, disabled]),
        onViewerClick = useCallback(() => onAccessChange("R"), [onAccessChange]),
        onEditorClick = useCallback(() => onAccessChange("RWS"), [onAccessChange])
  return (
    <ContextMenu
        gap={4}
        menuButton={contextTitle}
        shift={-68}
    >
      <Item
          checked={"R" === access}
          onClick={onViewerClick}
          type="checkbox"
      >
        Viewer
      </Item>
      <Item
          checked={"RW" === access || "RWS" === access || "RS" === access}
          onClick={onEditorClick}
          type="checkbox"
      >
        Editor
      </Item>
    </ContextMenu>
  )
}

AccessContextMenu.propTypes = {
  access: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  onAccessChange: PropTypes.func.isRequired
}

export default memo(AccessContextMenu)
